import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import Grupo from './grupo/Grupo';
import EmpresaTable from './grupo/EmpresaTable';
import { useAppDispatch, useAppSelector } from '../store';
import { getEntities as getProveedores } from './proveedor.reducer';
import Breadcrumb, { BreadcrumbItem } from '../commons/Breadcrumb';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaUserShield } from '@react-icons/all-files/fa/FaUserShield';
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding';
import { FaIndustry } from '@react-icons/all-files/fa/FaIndustry';

function ManagerBreadcrumb() {
    const location = useLocation();
    const grupoEntity = useAppSelector(state => state.grupoEmpresarial.entity) as any;
    const empresas    = useAppSelector(state => state.grupoEmpresarial.empresas) as any[];

    const match = location.pathname.match(
        /\/manager(?:\/grupo\/(\d+)(?:\/empresa\/(\d+))?)?/
    );
    const grupoId   = match?.[1];
    const empresaId = match?.[2];

    const items: BreadcrumbItem[] = [
        { label: 'Inicio',  to: '/',        icon: <FaHome /> },
        { label: 'Manager', to: '/manager', icon: <FaUserShield /> },
    ];

    if (grupoId) {
        const grupoLabel = grupoEntity?.alias ?? `Grupo ${grupoId}`;
        items.push({
            label: grupoLabel,
            to: empresaId ? `/manager/grupo/${grupoId}` : undefined,
            icon: <FaBuilding />,
        });
    }

    if (empresaId) {
        const empresa = empresas?.find((e: any) => String(e.id) === String(empresaId));
        const empresaLabel = empresa?.razonSocial ?? `Empresa ${empresaId}`;
        items.push({ label: empresaLabel, icon: <FaIndustry /> });
    }

    return <Breadcrumb items={items} />;
}

function Manager() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getProveedores({ size: 10000, page: 0 }));
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <ManagerBreadcrumb />
            <Routes>
                <Route path="/"                                  element={<EmpresaTable />} />
                <Route path="/grupo/:grupoId"                    element={<Grupo />} />
                <Route path="/grupo/:grupoId/empresa/:empresaId" element={<Grupo />} />
            </Routes>
        </div>
    );
}

export default Manager;
